<template>
  <SectionContent
    id="SectionGuarantees"
    background="blue"
    :content="$t('content')"
    :cta="$t('cta')"
    :ctaTo="ctaTo"
    icon="handshake-shield"
    :isVertical="false"
    :title="$t('title')" />
</template>

<script>
import SectionContent from 'views/components/SectionContent'

export default {
  components: { SectionContent },
  props: {
    ctaTo: Object,
  },
}
</script>

<style lang="scss">
#SectionGuarantees {}
</style>

<i18n>
{
  "lt": {
    "title": "Garantijos",
    "content": "###Suteikiame šias garantijas:\n\n####Moduliams\n\nSuteikiama 12 metų gamintojo produkto garantija ir 25-ių metų 84,8% efektyvumo garantija bei 25-ių metų gamintojo produkto garantija, 30-ies metų 85.95% efektyvumo garantija.\n\n####Įtampos keitikliui (inverteriui)\n\nSuteikiama 10-12 metų garantija su galimybe pratęsti iki 20-25-ių metų.\n\n####Tvirtinimo konstrukcijai\n\nSuteikiama 10-ies metų garantija su galimybe pratęsti iki 25 metų.\n\n####Ranga\n\n5 metų rangos garantija, 10 metų užslėpto defekto garantija, 20 metų tyčia paslėptų trūkumų garantija. Nogrid veikla yra apdrausta civilinės atsakomybės draudimu.",
    "guarantees": [
      {
        "label": "Moduliams",
        "text": "Suteikiama 12 metų gamintojo produkto garantija ir 25-ių metų 84,8% efektyvumo garantija bei 25-ių metų gamintojo produkto garantija, 30-ies metų 85.95% efektyvumo garantija."
      },
      {
        "label": "Įtampos keitikliui (inverteriui)",
        "text": "Suteikiama 10-12 metų garantija su galimybe pratęsti iki 20-25-ių metų."
      },
      {
        "label": "Tvirtinimo konstrukcijai",
        "text": "Suteikiama 10-ies metų garantija iki 25 metų."
      },
      {
        "label": "Ranga",
        "text": "5 metų rangos garantija, 10 metų užslėpto defekto garantija, 20 metų tyčia paslėptų trūkumų garantija. Nogrid veikla yra apdrausta civilinės atsakomybės draudimu."
      }
    ],
    "cta": "Gaukite pasiūlymą"
  }
}
</i18n>
